export const getConfirmationToTIDRedirectTimeout = (systemData = {}) => {
    const {isDesktop, environment} = systemData;

    if (isDesktop) {
        if (environment === 'production') {
            return 2000;
        }
        return 3000;
    }

    if (environment === 'production') {
        return 250;
    }
    return 1000;
};

export const isConfirmationToTIDRedirect = (
    isConfirmationToTID,
    tripViewId,
    tripItemId
) => {
    return !!isConfirmationToTID && !!tripViewId && !!tripItemId;
};
